import { Resource } from 'solid-js';
import { createStore } from 'solid-js/store';
import { BlogNewsData } from '../blog-news/blog-news';
import { ProductData } from '../product/product-types';
import type { PageData, PostData } from '../share-and-save/share-and-save';
import { EventData } from '../event/event-types';
// import { isServer } from 'solid-js/web';

type Output = OutputObject[];

type EntitySlugMap = {
    [key in EntitySlug]: string;
};
export type EntitySlug = 'product' | 'blog-and-news' | 'page' | 'event' | 'video-item';

export type FormattedPostItem = {
    key: string;
    type: EntitySlug;
    postTitle: string;
    objectID: string;
    url: string;
    hideOnWeb?: boolean; // Optional, will be false by default
    available?: boolean; // Optional, will be true by default
}


export type ValidDataTypes = ProductData & BlogNewsData & PageData & EventData & PostData

export type OutputObject = {
    key: string;
    type: EntitySlug;
    data: ValidDataTypes;
};

export type Collection = {
    id: string;
    title: string;
    orderedPosts: FormattedPostItem[];
    downloaded: boolean;
    createdAt: string;
    siteInfo: {
        siteId: string;
        domain?: string;
    };
};

type PDFBuilderState = {
    status: 
        | ''
        | 'naming'
        | 'printing'
        | 'error'
        | 'generating'
        | 'retrying-generating'
        | 'checking-availability'
        | 'server-busy'
        | 'editing'
        | 'deleting'
        | 'creating'
        | 'updating-existing';
    renderComplete: boolean;
    title: string;
    products: string[];
    articles: string[];
    workingCollectionPosts: FormattedPostItem[];
    collections: Collection[];
    postsData: Output;
    rawResource?: Resource<any>;
    entitySlugMap: EntitySlugMap;
    entityNameMap: EntitySlugMap;
    output: {
        blob: string;
        id: string;
    };
    debugging: boolean;
    debugMeasuredElementHeight: number;
    activeCollectionId: string;
};

export const supportedTypes: EntitySlug[] = ['product', 'blog-and-news', 'page', 'event'];

export const [ pdfStore, setPdfStore ] = createStore<PDFBuilderState>({
    status: '',
    renderComplete: false,
    title: '',
    products: [],
    articles: [],
    workingCollectionPosts: [],
    collections: [],
    postsData: [],
    entitySlugMap: {
        product: '',
        'blog-and-news': '',
        page: '',
        event: '',
        'video-item': '',
    },
    entityNameMap: {
        product: '',
        'blog-and-news': '',
        page: '',
        event: '',
        'video-item': '',
    },
    output: {
        blob: '',
        id: '',
    },
    debugging: false,
    debugMeasuredElementHeight: 0,
    activeCollectionId: '',
});


declare global {
    interface Window {
        pdfRenderComplete?: boolean;
    }
}

